var e=r=>!!r;var le=(r,t="lang")=>()=>[r?.params?.[t]].filter(e);export{le as initRequestParametersDetector};
